import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HiOutlineChevronRight, HiOutlineMenu } from "react-icons/hi";

import DashboardLayout from "layouts/dashboard/DashboardLayout";
import { getOppositionAttendHearing, getOppositionDiscussionDetails } from "api/opposition";
import InactiveStepView from "./InactiveStepView";
import OppositionPreliminaryDiscussionView, {
  OPPOSITION_PRELIMINARY_FORM_ID,
} from "./OppositionPreliminaryDiscussionView";
import OppositionApplicationDetailsFromClientView, {
  OPPOSITION_APPLICATION_DETAILS_FORM_ID,
} from "./OppositionApplicationDetailsFromClientView";
import OppositionStatusDetailsView, {
  OPPOSITION_STATUS_DETAILS_FORM_ID,
} from "./OppositionStatusDetailsView";
import OppositionNoticeToClientView, {
  OPPOSITION_NOTICE_TO_CLIENT_FORM_ID,
} from "./OppositionNoticeToClientView";
import OppositionInformClientView, {
  OPPOSITION_INFORM_CLIENT_FORM_ID,
} from "./OppositionInformClientView";
import OppositionCallClientView, {
  OPPOSITION_CALL_CLIENT_FORM_ID,
} from "./OppositionCallClientView";
import OppositionClientConfirmationView, {
  OPPOSITION_CLIENT_CONFIRMATION_FORM_ID,
} from "./OppositionClientConfirmationView";
import OppositionInvoiceToClientView, {
  OPPOSITION_INVOICE_TO_CLIENT_FORM_ID,
} from "./OppositionInvoiceToClientView";
import OppositionPaymentFromClientView, {
  OPPOSITION_PAYMENT_FROM_CLIENT_FORM_ID,
} from "./OppositionPaymentFromClientView";
import OppositionPrepareOppositionView, {
  OPPOSITION_PREPARE_FORM_ID,
} from "./OppositionPrepareOppositionView";
import OppositionFileOppositionView, {
  OPPOSITION_FILE_OPPOSITION_FORM_ID,
} from "./OppositionFileOppositionView";
import OppositionInformClientOfFilingView, {
  OPPOSITION_INFORM_CLIENT_OF_FILING_FORM_ID,
} from "./OppositionInformClientOfFilingView";
import OppositionInformClientOfNoticeOfOppositionView, {
  OPPOSITION_INFORM_CLIENT_OF_NOTICE_FORM_ID,
} from "./OppositionInformClientOfNoticeOfOppositionView";
import OppositionNoticeOfOppositionByRegistryView, {
  OPPOSITION_NOTICE_OF_OPPOSITION_FORM_ID,
} from "./OppositionNoticeOfOppositionByRegistryView";
import OppositionStatusDetailsForCounterView, {
  OPPOSITION_STATUS_DETAILS_FOR_COUNTER_FORM_ID,
} from "./OppositionStatusDetailsForCounterView";
import OppositionNoticeToClientForCounterView, {
  OPPOSITION_NOTICE_TO_CLIENT_FOR_COUNTER_FORM_ID,
} from "./OppositionNoticeToClientForCounterView";
import OppositionInformClientAboutCounterView, {
  OPPOSITION_INFORM_CLIENT_ABOUT_COUNTER_FORM_ID,
} from "./OppositionInformClientAboutCounterView";
import OppositionCallClientForEvidenceView, {
  OPPOSITION_CALL_CLIENT_FOR_EVIDENCE_FORM_ID,
} from "./OppositionCallClientForEvidenceView";
import OppositionConfirmationFromClientForEvidenceView, {
  OPPOSITION_CONFIRMATION_FOR_EVIDENCE_FORM_ID,
} from "./OppositionConfirmationFromClientForEvidenceView";
import OppositionInvoiceToClientForEvidenceView, {
  OPPOSITION_INVOICE_FOR_EVIDENCE_FORM_ID,
} from "./OppositionInvoiceToClientForEvidenceView";
import OppositionPaymentFromClientForEvidenceView, {
  OPPOSITION_PAYMENT_FOR_EVIDENCE_FORM_ID,
} from "./OppositionPaymentFromClientForEvidenceView";
import OppositionStampPaperDetailsToVendorView, {
  OPPOSITION_STAMP_PAPER_DETAILS_FORM_ID,
} from "./OppositionStampPaperDetailsToVendorView";
import OppositionStampPaperFromVendorView, {
  OPPOSITION_STAMP_PAPER_FROM_VENDOR_FORM_ID,
} from "./OppositionStampPaperFromVendorView";
import OppositionDocumentsFromClientForEvidenceView, {
  OPPOSITION_DOCUMENTS_FOR_EVIDENCE_FORM_ID,
} from "./OppositionDocumentsFromClientForEvidenceView";
import OppositionPreparationOfEvidenceAffidavitView, {
  OPPOSITION_PREPARATION_OF_EVIDENCE_AFFIDAVIT_FORM_ID,
} from "./OppositionPreparationOfEvidenceAffidavitView";
import OppositionSignatureFromClientForEvidenceView, {
  OPPOSITION_SIGNATURE_FOR_EVIDENCE_FORM_ID,
} from "./OppositionSignatureFromClientForEvidenceView";
import OppositionNotarisationForEvidenceView, {
  OPPOSITION_NOTARISATION_FOR_EVIDENCE_FORM_ID,
} from "./OppositionNotarisationForEvidenceView";
import OppositionScanningOfDocumentsForEvidenceView, {
  OPPOSITION_SCANNING_FOR_EVIDENCE_FORM_ID,
} from "./OppositionScanningOfDocumentsForEvidenceView";
import OppositionFileEvidenceAffidavitView, {
  OPPOSITION_FILE_EVIDENCE_AFFIDAVIT_FORM_ID,
} from "./OppositionFileEvidenceAffidavitView";
import OppositionInformClientAboutFilingOfEvidenceView, {
  OPPOSITION_INFORM_CLIENT_ABOUT_FILING_EVIDENCE_FORM_ID,
} from "./OppositionInformClientAboutFilingOfEvidenceView";
import OppositionStatusDetailsForEvidenceByCpView, {
  OPPOSITION_STATUS_DETAILS_FOR_EVIDENCE_BY_CP_FORM_ID,
} from "./OppositionStatusDetailsForEvidenceByCpView";
import OppositionNoticeForEvidenceByCpView, {
  OPPOSITION_NOTICE_FOR_EVIDENCE_BY_CP_FORM_ID,
} from "./OppositionNoticeForEvidenceByCpView";
import OppositionInformClientAboutEvidenceByCpView, {
  OPPOSITION_INFORM_CLIENT_ABOUT_EVIDENCE_BY_CP_FORM_ID,
} from "./OppositionInformClientAboutEvidenceByCpView";
import OppositionCallClientForRejoinderView, {
  OPPOSITION_CALL_CLIENT_FOR_REJOINDER_FORM_ID,
} from "./OppositionCallClientForRejoinderView";
import OppositionConfirmationFromClientForRejoinderView, {
  OPPOSITION_CONFIRMATION_FOR_REJOINDER_FORM_ID,
} from "./OppositionConfirmationFromClientForRejoinderView";
import OppositionInvoiceToClientForRejoinderView, {
  OPPOSITION_INVOICE_FOR_REJOINDER_FORM_ID,
} from "./OppositionInvoiceToClientForRejoinderView";
import OppositionPaymentFromClientForRejoinderView, {
  OPPOSITION_PAYMENT_FOR_REJOINDER_FORM_ID,
} from "./OppositionPaymentFromClientForRejoinderView";
import OppositionFileRejoinderView, {
  OPPOSITION_FILE_REJOINDER_FORM_ID,
} from "./OppositionFileRejoinderView";
import OppositionInformClientAboutFilingOfRejoinderView, {
  OPPOSITION_INFORM_CLIENT_ABOUT_FILING_REJOINDER_FORM_ID,
} from "./OppositionInformClientAboutFilingOfRejoinderView";
import OppositionStatusDetailsOfHearingView, {
  OPPOSITION_STATUS_OF_HEARING_FORM_ID,
} from "./OppositionStatusDetailsOfHearingView";
import OppositionNoticeToClientForHearingView, {
  OPPOSITION_NOTICE_FOR_HEARING_FORM_ID,
} from "./OppositionNoticeToClientForHearingView";
import OppositionInformClientAboutHearingView, {
  OPPOSITION_INFORM_CLIENT_ABOUT_HEARING_FORM_ID,
} from "./OppositionInformClientAboutHearingView";
import OppositionInvoiceToClientForHearingView, {
  OPPOSITION_INVOICE_FOR_HEARING_FORM_ID,
} from "./OppositionInvoiceToClientForHearingView";
import OppositionCallClientForHearingView, {
  OPPOSITION_CALL_CLIENT_FOR_HEARING_FORM_ID,
} from "./OppositionCallClientForHearingView";
import OppositionConfirmationFromClientForHearingView, {
  OPPOSITION_CONFIRMATION_FOR_HEARING_FORM_ID,
} from "./OppositionConfirmationFromClientForHearingView";
import OppositionInvoiceForTmMBeforeHearingView, {
  OPPOSITION_INVOICE_FOR_TMM_BEFORE_HEARING_FORM_ID,
} from "./OppositionInvoiceForTmMBeforeHearingView";
import OppositionPaymentForTmMBeforeHearingView, {
  OPPOSITION_PAYMENT_FOR_TMM_BEFORE_HEARING_FORM_ID,
} from "./OppositionPaymentForTmMBeforeHearingView";
import OppositionFileTmMBeforeHearingView, {
  OPPOSITION_FILE_TMM_BEFORE_HEARING_FORM_ID,
} from "./OppositionFileTmMBeforeHearingView";
import OppositionInformClientAboutFilingOfTmMBeforeHearingView, {
  OPPOSITION_INFORM_CLIENT_ABOUT_FILING_TMM_BEFORE_FORM_ID,
} from "./OppositionInformClientAboutFilingOfTmMBeforeHearingView";
import OppositionPaymentFromClientForHearingView, {
  OPPOSITION_PAYMENT_FOR_HEARING_FORM_ID,
} from "./OppositionPaymentFromClientForHearingView";
import OppositionDocumentsFromClientForHearingView, {
  OPPOSITION_DOCUMENTS_FOR_HEARING_FORM_ID,
} from "./OppositionDocumentsFromClientForHearingView";
import OppositionFilingOfHearingDocumentView, {
  OPPOSITION_FILING_OF_HEARING_DOCUMENT_FORM_ID,
} from "./OppositionFilingOfHearingDocumentView";
import OppositionNoteOnHearingView, {
  OPPOSITION_NOTE_ON_HEARING_FORM_ID,
} from "./OppositionNoteOnHearingView";
import OppositionAttendHearingView, {
  OPPOSITION_ATTEND_HEARING_FORM_ID,
} from "./OppositionAttendHearingView";
import OppositionInformClientAfterHearingView, {
  OPPOSITION_INFORM_CLIENT_AFTER_HEARING_FORM_ID,
} from "./OppositionInformClientAfterHearingView";
import OppositionInvoiceForTmMAfterHearingView, {
  OPPOSITION_INVOICE_FOR_TMM_AFTER_HEARING_FORM_ID,
} from "./OppositionInvoiceForTmMAfterHearingView";
import OppositionPaymentForTmMAfterHearingView, {
  OPPOSITION_PAYMENT_FOR_TMM_AFTER_HEARING_FORM_ID,
} from "./OppositionPaymentForTmMAfterHearingView";
import OppositionFileTmMAfterHearingView, {
  OPPOSITION_FILE_TMM_AFTER_HEARING_FORM_ID,
} from "./OppositionFileTmMAfterHearingView";
import OppositionInformClientAfterFilingTmMAfterHearingView, {
  OPPOSITION_INFORM_CLIENT_AFTER_FILING_TMM_AFTER_FORM_ID,
} from "./OppositionInformClientAfterFilingTmMAfterHearingView";
import OppositionSubsequentHearingsView, {
  OPPOSITION_SUBSEQUENT_HEARINGS_FORM_ID,
} from "./OppositionSubsequentHearingsView";
import OppositionFinalOrderToClientView, {
  OPPOSITION_FINAL_ORDER_FORM_ID,
} from "./OppositionFinalOrderToClientView";

// ---------------------------------------------------------------------------
// Step maps
// ---------------------------------------------------------------------------

type Section = "discussion" | "filing" | "status";

const DISCUSSION_ITEMS: { id: string; label: string }[] = [
  { id: "preliminary", label: "Preliminary Discussion with the Client for Opposition" },
  { id: "application-details", label: "Application Details from Client" },
  { id: "status-details", label: "Status Details" },
  { id: "notice-to-client", label: "Notice to Client" },
  { id: "inform-client", label: "Inform Client" },
  { id: "call-client", label: "Call Client for Opposition" },
  { id: "client-confirmation", label: "Client Confirmation" },
  { id: "invoice", label: "Invoice to Client" },
  { id: "payment", label: "Payment from Client" },
];

const DISCUSSION_ID_TO_SLUG: Record<string, string> = {
  preliminary: "preliminary-discussion-with-the-client",
  "application-details": "application-details-from-client",
  "status-details": "status-details",
  "notice-to-client": "notice-to-client",
  "inform-client": "inform-client",
  "call-client": "call-client-for-opposition",
  "client-confirmation": "client-confirmation",
  invoice: "invoice-to-client",
  payment: "payment-from-client",
};

const DISCUSSION_SLUG_TO_ID: Record<string, string> = Object.fromEntries(
  Object.entries(DISCUSSION_ID_TO_SLUG).map(([k, v]) => [v, k])
);

const FILING_ITEMS: { id: string; label: string }[] = [
  { id: "prepare-opposition", label: "Prepare Opposition" },
  { id: "file-opposition", label: "File Opposition" },
  { id: "inform-client-of-filing", label: "Inform Client of Filing" },
  { id: "notice-of-opposition", label: "Notice of Opposition by Registry" },
  { id: "inform-client-of-notice", label: "Inform Client of Notice of Opposition" },
];

const FILING_ID_TO_SLUG: Record<string, string> = {
  "prepare-opposition": "prepare-opposition",
  "file-opposition": "file-opposition",
  "inform-client-of-filing": "inform-client-of-filing",
  "notice-of-opposition": "notice-of-opposition-by-registry",
  "inform-client-of-notice": "inform-client-of-notice-of-opposition",
};

const FILING_SLUG_TO_ID: Record<string, string> = Object.fromEntries(
  Object.entries(FILING_ID_TO_SLUG).map(([k, v]) => [v, k])
);

const STATUS_ITEMS: { id: string; label: string }[] = [
  { id: "status-details-counter", label: "Status details for Counter by Conflicting Proprietor" },
  { id: "notice-counter", label: "Notice to Client for Counter by Conflicting Proprietor" },
  { id: "inform-counter", label: "Inform Client about Counter by Conflicting Proprietor" },
  { id: "call-evidence", label: "Call Client for Evidence by Opponent" },
  { id: "confirmation-evidence", label: "Confirmation from Client for Evidence by Opponent" },
  { id: "invoice-evidence", label: "Invoice to Client for Evidence by Opponent" },
  { id: "payment-evidence", label: "Payment from Client for Evidence by Opponent" },
  { id: "stamp-paper-to-vendor", label: "Stamp Paper details to Vendor for Evidence" },
  { id: "stamp-paper-from-vendor", label: "Stamp Paper from Vendor for Evidence" },
  { id: "documents-evidence", label: "Documents from Client for Evidence by Opponent" },
  { id: "preparation-evidence", label: "Preparation of Evidence Affidavit by Opponent" },
  { id: "signature-evidence", label: "Signature from Client for Evidence by Opponent" },
  { id: "notarisation-evidence", label: "Notarisation of Documents for Evidence by Opponent" },
  { id: "scanning-evidence", label: "Scanning of Documents for Evidence by Opponent" },
  { id: "file-evidence-affidavit", label: "File Evidence Affidavit by Opponent" },
  { id: "inform-filing-evidence", label: "Inform Client about Filing of Evidence by Opponent" },
  { id: "status-evidence-by-cp", label: "Status details for Evidence by Conflicting Proprietor" },
  { id: "notice-evidence-by-cp", label: "Notice to Client for Evidence by Conflicting Proprietor" },
  { id: "inform-evidence-by-cp", label: "Inform Client about Evidence by Conflicting Proprietor" },
  { id: "call-rejoinder", label: "Call Client for Rejoinder by Opponent" },
  { id: "confirmation-rejoinder", label: "Confirmation from Client for Rejoinder by Opponent" },
  { id: "invoice-rejoinder", label: "Invoice to Client for Rejoinder by Opponent" },
  { id: "payment-rejoinder", label: "Payment from Client for Rejoinder by Opponent" },
  { id: "file-rejoinder", label: "File Rejoinder by Opponent" },
  { id: "inform-filing-rejoinder", label: "Inform Client about Filing of Rejoinder by Opponent" },
  { id: "status-hearing", label: "Status details of Opposition Hearing" },
  { id: "notice-hearing", label: "Notice to Client for Opposition Hearing" },
  { id: "inform-hearing", label: "Inform Client about Opposition Hearing" },
  { id: "invoice-hearing", label: "Invoice to Client for Opposition Hearing" },
  { id: "call-hearing", label: "Call Client for Opposition Hearing" },
  { id: "confirmation-hearing", label: "Confirmation from Client for Opposition Hearing" },
  { id: "invoice-tmm-before", label: "Invoice for TM-M before Opposition Hearing" },
  { id: "payment-tmm-before", label: "Payment from Client for TM-M before Opposition Hearing" },
  { id: "file-tmm-before", label: "File TM-M before Opposition Hearing" },
  { id: "inform-filing-tmm-before", label: "Inform Client about Filing of TM-M before Opposition Hearing" },
  { id: "payment-hearing", label: "Payment from Client for Opposition Hearing" },
  { id: "documents-hearing", label: "Documents from Client for Opposition Hearing" },
  { id: "filing-hearing-document", label: "Filing of Opposition Hearing Document" },
  { id: "note-on-hearing", label: "Note on Opposition Hearing" },
  { id: "attend-hearing", label: "Attend Opposition Hearing" },
  { id: "inform-after-hearing", label: "Inform Client after Opposition Hearing" },
  { id: "invoice-tmm-after", label: "Invoice for TM-M after Opposition Hearing" },
  { id: "payment-tmm-after", label: "Payment from Client for TM-M after Opposition Hearing" },
  { id: "file-tmm-after", label: "File TM-M after Opposition Hearing" },
  { id: "inform-filing-tmm-after", label: "Inform Client after Filing TM-M after Opposition Hearing" },
  { id: "subsequent-hearings", label: "Subsequent Hearings" },
  { id: "final-order", label: "Final Order to Client about Opposition" },
];

const STATUS_ID_TO_SLUG: Record<string, string> = {
  "status-details-counter": "status-details-for-counter-by-conflicting-proprietor",
  "notice-counter": "notice-to-client-for-counter-by-conflicting-proprietor",
  "inform-counter": "inform-client-about-counter-by-conflicting-proprietor",
  "call-evidence": "call-client-for-evidence-by-opponent",
  "confirmation-evidence": "confirmation-from-client-for-evidence-by-opponent",
  "invoice-evidence": "invoice-to-client-for-evidence-by-opponent",
  "payment-evidence": "payment-from-client-for-evidence-by-opponent",
  "stamp-paper-to-vendor": "stamp-paper-details-to-vendor-for-evidence",
  "stamp-paper-from-vendor": "stamp-paper-from-vendor-for-evidence",
  "documents-evidence": "documents-from-client-for-evidence-by-opponent",
  "preparation-evidence": "preparation-of-evidence-affidavit-by-opponent",
  "signature-evidence": "signature-from-client-for-evidence-by-opponent",
  "notarisation-evidence": "notarisation-of-documents-for-evidence-by-opponent",
  "scanning-evidence": "scanning-of-documents-for-evidence-by-opponent",
  "file-evidence-affidavit": "file-evidence-affidavit-by-opponent",
  "inform-filing-evidence": "inform-client-about-filing-of-evidence-by-opponent",
  "status-evidence-by-cp": "status-details-for-evidence-by-conflicting-proprietor",
  "notice-evidence-by-cp": "notice-to-client-for-evidence-by-conflicting-proprietor",
  "inform-evidence-by-cp": "inform-client-about-evidence-by-conflicting-proprietor",
  "call-rejoinder": "call-client-for-rejoinder-by-opponent",
  "confirmation-rejoinder": "confirmation-from-client-for-rejoinder-by-opponent",
  "invoice-rejoinder": "invoice-to-client-for-rejoinder-by-opponent",
  "payment-rejoinder": "payment-from-client-for-rejoinder-by-opponent",
  "file-rejoinder": "file-rejoinder-by-opponent",
  "inform-filing-rejoinder": "inform-client-about-filing-of-rejoinder-by-opponent",
  "status-hearing": "status-details-of-opposition-hearing",
  "notice-hearing": "notice-to-client-for-opposition-hearing",
  "inform-hearing": "inform-client-about-opposition-hearing",
  "invoice-hearing": "invoice-to-client-for-opposition-hearing",
  "call-hearing": "call-client-for-opposition-hearing",
  "confirmation-hearing": "confirmation-from-client-for-opposition-hearing",
  "invoice-tmm-before": "invoice-for-tm-m-before-opposition-hearing",
  "payment-tmm-before": "payment-from-client-for-tm-m-before-opposition-hearing",
  "file-tmm-before": "file-tm-m-before-opposition-hearing",
  "inform-filing-tmm-before": "inform-client-about-filing-of-tm-m-before-opposition-hearing",
  "payment-hearing": "payment-from-client-for-opposition-hearing",
  "documents-hearing": "documents-from-client-for-opposition-hearing",
  "filing-hearing-document": "filing-of-opposition-hearing-document",
  "note-on-hearing": "note-on-opposition-hearing",
  "attend-hearing": "attend-opposition-hearing",
  "inform-after-hearing": "inform-client-after-opposition-hearing",
  "invoice-tmm-after": "invoice-for-tm-m-after-opposition-hearing",
  "payment-tmm-after": "payment-from-client-for-tm-m-after-opposition-hearing",
  "file-tmm-after": "file-tm-m-after-opposition-hearing",
  "inform-filing-tmm-after": "inform-client-after-filing-tm-m-after-opposition-hearing",
  "subsequent-hearings": "subsequent-hearings",
  "final-order": "final-order-to-client-about-opposition",
};

const STATUS_SLUG_TO_ID: Record<string, string> = Object.fromEntries(
  Object.entries(STATUS_ID_TO_SLUG).map(([k, v]) => [v, k])
);

const FORM_MAP: Record<string, string | undefined> = {
  preliminary: OPPOSITION_PRELIMINARY_FORM_ID,
  "application-details": OPPOSITION_APPLICATION_DETAILS_FORM_ID,
  "status-details": OPPOSITION_STATUS_DETAILS_FORM_ID,
  "notice-to-client": OPPOSITION_NOTICE_TO_CLIENT_FORM_ID,
  "inform-client": OPPOSITION_INFORM_CLIENT_FORM_ID,
  "call-client": OPPOSITION_CALL_CLIENT_FORM_ID,
  "client-confirmation": OPPOSITION_CLIENT_CONFIRMATION_FORM_ID,
  invoice: OPPOSITION_INVOICE_TO_CLIENT_FORM_ID,
  payment: OPPOSITION_PAYMENT_FROM_CLIENT_FORM_ID,
  "prepare-opposition": OPPOSITION_PREPARE_FORM_ID,
  "file-opposition": OPPOSITION_FILE_OPPOSITION_FORM_ID,
  "inform-client-of-filing": OPPOSITION_INFORM_CLIENT_OF_FILING_FORM_ID,
  "notice-of-opposition": OPPOSITION_NOTICE_OF_OPPOSITION_FORM_ID,
  "inform-client-of-notice": OPPOSITION_INFORM_CLIENT_OF_NOTICE_FORM_ID,
  "status-details-counter": OPPOSITION_STATUS_DETAILS_FOR_COUNTER_FORM_ID,
  "notice-counter": OPPOSITION_NOTICE_TO_CLIENT_FOR_COUNTER_FORM_ID,
  "inform-counter": OPPOSITION_INFORM_CLIENT_ABOUT_COUNTER_FORM_ID,
  "call-evidence": OPPOSITION_CALL_CLIENT_FOR_EVIDENCE_FORM_ID,
  "confirmation-evidence": OPPOSITION_CONFIRMATION_FOR_EVIDENCE_FORM_ID,
  "invoice-evidence": OPPOSITION_INVOICE_FOR_EVIDENCE_FORM_ID,
  "payment-evidence": OPPOSITION_PAYMENT_FOR_EVIDENCE_FORM_ID,
  "stamp-paper-to-vendor": OPPOSITION_STAMP_PAPER_DETAILS_FORM_ID,
  "stamp-paper-from-vendor": OPPOSITION_STAMP_PAPER_FROM_VENDOR_FORM_ID,
  "documents-evidence": OPPOSITION_DOCUMENTS_FOR_EVIDENCE_FORM_ID,
  "preparation-evidence": OPPOSITION_PREPARATION_OF_EVIDENCE_AFFIDAVIT_FORM_ID,
  "signature-evidence": OPPOSITION_SIGNATURE_FOR_EVIDENCE_FORM_ID,
  "notarisation-evidence": OPPOSITION_NOTARISATION_FOR_EVIDENCE_FORM_ID,
  "scanning-evidence": OPPOSITION_SCANNING_FOR_EVIDENCE_FORM_ID,
  "file-evidence-affidavit": OPPOSITION_FILE_EVIDENCE_AFFIDAVIT_FORM_ID,
  "inform-filing-evidence": OPPOSITION_INFORM_CLIENT_ABOUT_FILING_EVIDENCE_FORM_ID,
  "status-evidence-by-cp": OPPOSITION_STATUS_DETAILS_FOR_EVIDENCE_BY_CP_FORM_ID,
  "notice-evidence-by-cp": OPPOSITION_NOTICE_FOR_EVIDENCE_BY_CP_FORM_ID,
  "inform-evidence-by-cp": OPPOSITION_INFORM_CLIENT_ABOUT_EVIDENCE_BY_CP_FORM_ID,
  "call-rejoinder": OPPOSITION_CALL_CLIENT_FOR_REJOINDER_FORM_ID,
  "confirmation-rejoinder": OPPOSITION_CONFIRMATION_FOR_REJOINDER_FORM_ID,
  "invoice-rejoinder": OPPOSITION_INVOICE_FOR_REJOINDER_FORM_ID,
  "payment-rejoinder": OPPOSITION_PAYMENT_FOR_REJOINDER_FORM_ID,
  "file-rejoinder": OPPOSITION_FILE_REJOINDER_FORM_ID,
  "inform-filing-rejoinder": OPPOSITION_INFORM_CLIENT_ABOUT_FILING_REJOINDER_FORM_ID,
  "status-hearing": OPPOSITION_STATUS_OF_HEARING_FORM_ID,
  "notice-hearing": OPPOSITION_NOTICE_FOR_HEARING_FORM_ID,
  "inform-hearing": OPPOSITION_INFORM_CLIENT_ABOUT_HEARING_FORM_ID,
  "invoice-hearing": OPPOSITION_INVOICE_FOR_HEARING_FORM_ID,
  "call-hearing": OPPOSITION_CALL_CLIENT_FOR_HEARING_FORM_ID,
  "confirmation-hearing": OPPOSITION_CONFIRMATION_FOR_HEARING_FORM_ID,
  "invoice-tmm-before": OPPOSITION_INVOICE_FOR_TMM_BEFORE_HEARING_FORM_ID,
  "payment-tmm-before": OPPOSITION_PAYMENT_FOR_TMM_BEFORE_HEARING_FORM_ID,
  "file-tmm-before": OPPOSITION_FILE_TMM_BEFORE_HEARING_FORM_ID,
  "inform-filing-tmm-before": OPPOSITION_INFORM_CLIENT_ABOUT_FILING_TMM_BEFORE_FORM_ID,
  "payment-hearing": OPPOSITION_PAYMENT_FOR_HEARING_FORM_ID,
  "documents-hearing": OPPOSITION_DOCUMENTS_FOR_HEARING_FORM_ID,
  "filing-hearing-document": OPPOSITION_FILING_OF_HEARING_DOCUMENT_FORM_ID,
  "note-on-hearing": OPPOSITION_NOTE_ON_HEARING_FORM_ID,
  "attend-hearing": OPPOSITION_ATTEND_HEARING_FORM_ID,
  "inform-after-hearing": OPPOSITION_INFORM_CLIENT_AFTER_HEARING_FORM_ID,
  "invoice-tmm-after": OPPOSITION_INVOICE_FOR_TMM_AFTER_HEARING_FORM_ID,
  "payment-tmm-after": OPPOSITION_PAYMENT_FOR_TMM_AFTER_HEARING_FORM_ID,
  "file-tmm-after": OPPOSITION_FILE_TMM_AFTER_HEARING_FORM_ID,
  "inform-filing-tmm-after": OPPOSITION_INFORM_CLIENT_AFTER_FILING_TMM_AFTER_FORM_ID,
  "subsequent-hearings": OPPOSITION_SUBSEQUENT_HEARINGS_FORM_ID,
  "final-order": OPPOSITION_FINAL_ORDER_FORM_ID,
};

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function DashboardOpposition() {
  const navigate = useNavigate();
  const { section, step, leadId } = useParams<{
    section?: string;
    step?: string;
    leadId?: string;
  }>();

  const [menuOpen, setMenuOpen] = useState(false);
  const [markNameForHeader, setMarkNameForHeader] = useState<string | null>(null);
  const [noticeSent, setNoticeSent] = useState(false);
  const [informClientSent, setInformClientSent] = useState(false);
  const [invoiceSent, setInvoiceSent] = useState(false);
  const [informClientOfFilingSent, setInformClientOfFilingSent] = useState(false);
  const [informClientOfNoticeSent, setInformClientOfNoticeSent] = useState(false);
  const [noticeCounterSent, setNoticeCounterSent] = useState(false);
  const [informCounterSent, setInformCounterSent] = useState(false);
  const [invoiceEvidenceSent, setInvoiceEvidenceSent] = useState(false);
  const [stampPaperToVendorSent, setStampPaperToVendorSent] = useState(false);
  const [informFilingEvidenceSent, setInformFilingEvidenceSent] = useState(false);
  const [noticeEvidenceByCpSent, setNoticeEvidenceByCpSent] = useState(false);
  const [informEvidenceByCpSent, setInformEvidenceByCpSent] = useState(false);
  const [invoiceRejoinderSent, setInvoiceRejoinderSent] = useState(false);
  const [informFilingRejoinderSent, setInformFilingRejoinderSent] = useState(false);
  const [noticeHearingSent, setNoticeHearingSent] = useState(false);
  const [informHearingSent, setInformHearingSent] = useState(false);
  const [invoiceHearingSent, setInvoiceHearingSent] = useState(false);
  const [invoiceTmMBeforeSent, setInvoiceTmMBeforeSent] = useState(false);
  const [informFilingTmMBeforeSent, setInformFilingTmMBeforeSent] = useState(false);
  const [informAfterHearingSent, setInformAfterHearingSent] = useState(false);
  const [invoiceTmMAfterSent, setInvoiceTmMAfterSent] = useState(false);
  const [informFilingTmMAfterSent, setInformFilingTmMAfterSent] = useState(false);

  // Routing flags driven by Substep 4A(xliv): Attend Opposition Hearing outcomes.
  // - tmMFlowActive: any conflicting mark's remark is FILE_TM_M → keep 4A(xlvi–xlix) active.
  // - subsequentHearingsActive: any mark's hearing status is DIDNT_HAPPEN → keep 4A(l) active.
  // - informAfterHearingActive: at least one mark needs Step 41 (i.e. not all marks are
  //   DIDNT_HAPPEN). False only when every mark's saved status is DIDNT_HAPPEN — there
  //   is no hearing outcome to inform the client about, so 4A(xlv) is skipped.
  //   Defaults to true (initial render before flags are fetched) so the stepper
  //   doesn't accidentally hide Step 41 for leads that haven't saved attend-hearing yet.
  const [tmMFlowActive, setTmMFlowActive] = useState(false);
  const [subsequentHearingsActive, setSubsequentHearingsActive] = useState(false);
  const [informAfterHearingActive, setInformAfterHearingActive] = useState(true);

  type AttendHearingRoutingFlags = {
    tmMFlowActive: boolean;
    subsequentHearingsActive: boolean;
    informAfterHearingActive: boolean;
  };

  const DEFAULT_ROUTING_FLAGS: AttendHearingRoutingFlags = {
    tmMFlowActive: false,
    subsequentHearingsActive: false,
    informAfterHearingActive: true,
  };

  // Returns the freshly-fetched flags so callers can route off them in the same
  // microtask. setState updates are async, so reading state in `.then(...)` after
  // a setter still sees the previous value — which would otherwise cause the
  // DIDNT_HAPPEN save to advance to Inform-after-Hearing instead of skipping it.
  const refreshAttendHearingFlags = async (
    currentLeadId: string | null | undefined,
  ): Promise<AttendHearingRoutingFlags> => {
    if (!currentLeadId) {
      setTmMFlowActive(DEFAULT_ROUTING_FLAGS.tmMFlowActive);
      setSubsequentHearingsActive(DEFAULT_ROUTING_FLAGS.subsequentHearingsActive);
      setInformAfterHearingActive(DEFAULT_ROUTING_FLAGS.informAfterHearingActive);
      return DEFAULT_ROUTING_FLAGS;
    }
    try {
      const data = await getOppositionAttendHearing(currentLeadId);
      const next: AttendHearingRoutingFlags = {
        tmMFlowActive: data.anyRequiresTmMFiling,
        subsequentHearingsActive: data.anyRequiresSubsequentHearing,
        informAfterHearingActive: data.anyRequiresInformAfterHearing,
      };
      setTmMFlowActive(next.tmMFlowActive);
      setSubsequentHearingsActive(next.subsequentHearingsActive);
      setInformAfterHearingActive(next.informAfterHearingActive);
      return next;
    } catch {
      setTmMFlowActive(DEFAULT_ROUTING_FLAGS.tmMFlowActive);
      setSubsequentHearingsActive(DEFAULT_ROUTING_FLAGS.subsequentHearingsActive);
      setInformAfterHearingActive(DEFAULT_ROUTING_FLAGS.informAfterHearingActive);
      return DEFAULT_ROUTING_FLAGS;
    }
  };

  useEffect(() => {
    if (!leadId) {
      setMarkNameForHeader(null);
      setTmMFlowActive(false);
      setSubsequentHearingsActive(false);
      setInformAfterHearingActive(true);
      return;
    }
    let cancelled = false;
    getOppositionDiscussionDetails(leadId)
      .then((details) => {
        if (!cancelled) setMarkNameForHeader(details.preliminary.markName ?? null);
      })
      .catch(() => {
        if (!cancelled) setMarkNameForHeader(null);
      });
    getOppositionAttendHearing(leadId)
      .then((data) => {
        if (cancelled) return;
        setTmMFlowActive(data.anyRequiresTmMFiling);
        setSubsequentHearingsActive(data.anyRequiresSubsequentHearing);
        setInformAfterHearingActive(data.anyRequiresInformAfterHearing);
      })
      .catch(() => {
        if (!cancelled) {
          setTmMFlowActive(false);
          setSubsequentHearingsActive(false);
          setInformAfterHearingActive(true);
        }
      });
    return () => { cancelled = true; };
  }, [leadId]);

  const activeTab: Section =
    section === "filing" ? "filing" : section === "status" ? "status" : "discussion";

  const activeMenuItem =
    activeTab === "discussion" && step
      ? (DISCUSSION_SLUG_TO_ID[step] ?? "preliminary")
      : activeTab === "filing" && step
        ? (FILING_SLUG_TO_ID[step] ?? "prepare-opposition")
        : activeTab === "status" && step
          ? (STATUS_SLUG_TO_ID[step] ?? "status-details-counter")
          : activeTab === "filing"
            ? "prepare-opposition"
            : activeTab === "status"
              ? "status-details-counter"
              : "preliminary";

  useEffect(() => {
    if (!section || !step) {
      navigate(
        "/dashboard/opposition/new/discussion/preliminary-discussion-with-the-client",
        { replace: true }
      );
    }
  }, [section, step, navigate]);

  const navigateToStep = (
    tab: Section,
    itemId: string,
    currentLeadId?: string | null
  ) => {
    const slug =
      tab === "discussion"
        ? DISCUSSION_ID_TO_SLUG[itemId]
        : tab === "filing"
          ? FILING_ID_TO_SLUG[itemId]
          : STATUS_ID_TO_SLUG[itemId];
    if (!slug) return;
    const base = `/dashboard/opposition/new/${tab}/${slug}`;
    const path = currentLeadId ? `${base}/${currentLeadId}` : base;
    navigate(path);
    setMenuOpen(false);
  };

  // Substep ids in the Status tab that are conditional on the Attend-Opposition-Hearing outcome.
  // - TM-M-after-Hearing chain (4A(xlvi)–4A(xlix)) is skipped unless any mark's remark is FILE_TM_M.
  // - Subsequent Opposition Hearings (4A(l)) is skipped unless any mark's status is DIDNT_HAPPEN.
  const TMM_AFTER_HEARING_IDS = new Set([
    "invoice-tmm-after",
    "payment-tmm-after",
    "file-tmm-after",
    "inform-filing-tmm-after",
  ]);

  const isStatusStepActiveWith = (
    itemId: string,
    flags: AttendHearingRoutingFlags,
  ): boolean => {
    if (itemId === "inform-after-hearing") return flags.informAfterHearingActive;
    if (TMM_AFTER_HEARING_IDS.has(itemId)) return flags.tmMFlowActive;
    if (itemId === "subsequent-hearings") return flags.subsequentHearingsActive;
    return true;
  };

  const currentRoutingFlags = (): AttendHearingRoutingFlags => ({
    tmMFlowActive,
    subsequentHearingsActive,
    informAfterHearingActive,
  });

  const isStatusStepActive = (itemId: string): boolean =>
    isStatusStepActiveWith(itemId, currentRoutingFlags());

  const findNextActiveStatusStepWith = (
    fromItemId: string,
    flags: AttendHearingRoutingFlags,
  ): string | null => {
    const startIdx = STATUS_ITEMS.findIndex((m) => m.id === fromItemId);
    if (startIdx < 0) return null;
    for (let i = startIdx + 1; i < STATUS_ITEMS.length; i += 1) {
      if (isStatusStepActiveWith(STATUS_ITEMS[i].id, flags)) return STATUS_ITEMS[i].id;
    }
    return null;
  };

  const findPrevActiveStatusStep = (fromItemId: string): string | null => {
    const flags = currentRoutingFlags();
    const startIdx = STATUS_ITEMS.findIndex((m) => m.id === fromItemId);
    if (startIdx <= 0) return null;
    for (let i = startIdx - 1; i >= 0; i -= 1) {
      if (isStatusStepActiveWith(STATUS_ITEMS[i].id, flags)) return STATUS_ITEMS[i].id;
    }
    return null;
  };

  const advanceFromStatusStep = (
    currentItemId: string,
    currentLeadId: string | null | undefined,
    flagsOverride?: AttendHearingRoutingFlags,
  ) => {
    // After saving Attend Hearing the caller passes freshly-fetched flags here so we
    // don't read stale state via closure (setState updates are async).
    const flags = flagsOverride ?? currentRoutingFlags();
    const next = findNextActiveStatusStepWith(currentItemId, flags);
    if (next) {
      navigateToStep("status", next, currentLeadId);
    } else {
      // No active downstream step — stay on the current one rather than navigating to a hidden step.
      navigateToStep("status", currentItemId, currentLeadId);
    }
  };

  const handleTabChange = (tab: Section) => {
    const firstStep =
      tab === "filing"
        ? "prepare-opposition"
        : tab === "status"
          ? "status-details-counter"
          : "preliminary";
    const slug =
      tab === "filing"
        ? FILING_ID_TO_SLUG[firstStep]
        : tab === "status"
          ? STATUS_ID_TO_SLUG[firstStep]
          : DISCUSSION_ID_TO_SLUG[firstStep];
    const path = leadId
      ? `/dashboard/opposition/new/${tab}/${slug}/${leadId}`
      : `/dashboard/opposition/new/${tab}/${slug}`;
    navigate(path);
  };

  const leftPanelItems =
    activeTab === "filing"
      ? FILING_ITEMS
      : activeTab === "status"
        ? STATUS_ITEMS
        : DISCUSSION_ITEMS;

  const activeLeftId = activeMenuItem;
  const activeIdx = leftPanelItems.findIndex((m) => m.id === activeLeftId);
  // In the Status tab, Back should skip substeps that don't apply to this lead
  // (TM-M-after-Hearing chain and Subsequent Hearings) per the 4A(xliv) outcome.
  const prevStatusStepId =
    activeTab === "status" ? findPrevActiveStatusStep(activeLeftId) : null;
  const canGoBack =
    activeTab === "status" ? prevStatusStepId !== null : activeIdx > 0;

  const submitForm = FORM_MAP[activeMenuItem] ?? null;
  const primaryActionLabel =
    activeMenuItem === "notice-to-client"
      ? noticeSent
        ? "Save and Continue"
        : "Send and Continue"
      : activeMenuItem === "inform-client"
        ? informClientSent
          ? "Save and Continue"
          : "Send and Continue"
        : activeMenuItem === "invoice"
          ? invoiceSent
            ? "Save and Continue"
            : "Send and Continue"
          : activeMenuItem === "inform-client-of-filing"
            ? informClientOfFilingSent
              ? "Save and Continue"
              : "Send and Continue"
            : activeMenuItem === "inform-client-of-notice"
              ? informClientOfNoticeSent
                ? "Save and Continue"
                : "Send and Continue"
              : activeMenuItem === "notice-counter"
                ? noticeCounterSent
                  ? "Save and Continue"
                  : "Send and Continue"
                : activeMenuItem === "inform-counter"
                  ? informCounterSent
                    ? "Save and Continue"
                    : "Send and Continue"
                  : activeMenuItem === "invoice-evidence"
                    ? invoiceEvidenceSent
                      ? "Save and Continue"
                      : "Send and Continue"
                    : activeMenuItem === "stamp-paper-to-vendor"
                      ? stampPaperToVendorSent
                        ? "Save and Continue"
                        : "Send and Continue"
                      : activeMenuItem === "inform-filing-evidence"
                        ? informFilingEvidenceSent
                          ? "Save and Continue"
                          : "Send and Continue"
                        : activeMenuItem === "notice-evidence-by-cp"
                          ? noticeEvidenceByCpSent
                            ? "Save and Continue"
                            : "Send and Continue"
                          : activeMenuItem === "inform-evidence-by-cp"
                            ? informEvidenceByCpSent
                              ? "Save and Continue"
                              : "Send and Continue"
                            : activeMenuItem === "invoice-rejoinder"
                              ? invoiceRejoinderSent
                                ? "Save and Continue"
                                : "Send and Continue"
                              : activeMenuItem === "inform-filing-rejoinder"
                                ? informFilingRejoinderSent
                                  ? "Save and Continue"
                                  : "Send and Continue"
                                : activeMenuItem === "notice-hearing"
                                  ? noticeHearingSent
                                    ? "Save and Continue"
                                    : "Send and Continue"
                                  : activeMenuItem === "inform-hearing"
                                    ? informHearingSent
                                      ? "Save and Continue"
                                      : "Send and Continue"
                                    : activeMenuItem === "invoice-hearing"
                                      ? invoiceHearingSent
                                        ? "Save and Continue"
                                        : "Send and Continue"
                                      : activeMenuItem === "invoice-tmm-before"
                                        ? invoiceTmMBeforeSent
                                          ? "Save and Continue"
                                          : "Send and Continue"
                                        : activeMenuItem === "inform-filing-tmm-before"
                                          ? informFilingTmMBeforeSent
                                            ? "Save and Continue"
                                            : "Send and Continue"
                                          : activeMenuItem === "inform-after-hearing"
                                            ? informAfterHearingSent
                                              ? "Save and Continue"
                                              : "Send and Continue"
                                            : activeMenuItem === "invoice-tmm-after"
                                              ? invoiceTmMAfterSent
                                                ? "Save and Continue"
                                                : "Send and Continue"
                                              : activeMenuItem === "inform-filing-tmm-after"
                                                ? informFilingTmMAfterSent
                                                  ? "Save and Continue"
                                                  : "Send and Continue"
                                                : activeMenuItem === "final-order"
                                                  ? "Save"
                                                  : "Save & Continue";

  return (
    <DashboardLayout headerTitle="Opposition" headerLeadNo={markNameForHeader ?? undefined} hideHeaderOnMobile>
      <div className="flex-1 p-2 min-h-0 flex flex-col min-w-0">
        <div className="bg-white rounded-[8px] h-full flex flex-col overflow-hidden">
          {/* Tab bar */}
          <div className="flex items-center gap-0 border-b border-[#EEEEEE] pl-[10px] pt-[6px] flex-shrink-0">
            {(["discussion", "filing", "status"] as Section[]).map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabChange(tab)}
                className={`px-2.5 py-2.5 text-[14px] leading-5 -mb-px border-b-2 transition-colors capitalize ${
                  activeTab === tab
                    ? "font-semibold text-[#222] border-[#222]"
                    : "font-normal text-[#222] border-transparent"
                }`}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          {/* Mobile header */}
          <div className="md:hidden flex items-center gap-3 h-[65px] px-4 border-b border-[#E5E7EB] flex-shrink-0">
            <button
              type="button"
              aria-label="Open menu"
              onClick={() => setMenuOpen(true)}
              className="flex items-center justify-center rounded-[10px] w-9 h-9 min-w-[36px] min-h-[36px] hover:bg-[#F7F7F7]"
            >
              <HiOutlineMenu className="w-5 h-5 text-[#222]" strokeWidth={1.5} />
            </button>
            <div className="flex-1 min-w-0 font-medium text-[14px] leading-5 text-[#242424] truncate">
              Opposition{markNameForHeader ? ` | ${markNameForHeader}` : ""}
            </div>
          </div>

          <div className="flex flex-1 overflow-hidden relative">
            {/* Mobile overlay */}
            {menuOpen && (
              <div
                className="absolute inset-0 bg-black/20 z-40 md:hidden"
                onClick={() => setMenuOpen(false)}
              />
            )}

            {/* Left panel */}
            <div
              className={`w-[279px] border-r border-[#EEEEEE] bg-white p-2.5 overflow-y-auto flex-shrink-0 ${
                menuOpen
                  ? "absolute left-0 top-0 bottom-0 z-50 md:relative"
                  : "hidden md:block"
              }`}
            >
              <div className="flex flex-col gap-2">
                {leftPanelItems.map((item) => {
                  const isInactive =
                    activeTab === "status" && !isStatusStepActive(item.id);
                  const isSelected = activeLeftId === item.id;
                  return (
                    <button
                      key={item.id}
                      onClick={() => navigateToStep(activeTab, item.id, leadId ?? null)}
                      className={`w-full flex items-center justify-between px-2.5 py-2.5 gap-2.5 rounded-[6px] text-xs ${
                        isSelected
                          ? "bg-[#222222] text-white font-medium"
                          : isInactive
                            ? "bg-[#F7F7F7] text-[#A0A0A0] font-normal"
                            : "bg-[#F7F7F7] text-[#222222] font-normal"
                      } hover:bg-opacity-90 transition-colors`}
                      title={
                        isInactive
                          ? "Not required for this lead based on the Opposition Hearing outcome"
                          : undefined
                      }
                    >
                      <span className="text-left line-clamp-1">{item.label}</span>
                      <HiOutlineChevronRight className="w-4 h-4 flex-shrink-0 ml-1" strokeWidth={1.5} />
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Main content */}
            <div className="flex-1 flex flex-col min-w-0">
              <div className="flex-1 p-5 md:p-6 overflow-y-auto">
                {activeTab === "discussion" && activeMenuItem === "preliminary" ? (
                  <OppositionPreliminaryDiscussionView
                    leadId={leadId ?? undefined}
                    onSuccess={(newLeadId) => {
                      navigateToStep("discussion", "application-details", newLeadId);
                    }}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "application-details" ? (
                  <OppositionApplicationDetailsFromClientView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("discussion", "status-details", savedLeadId);
                    }}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "status-details" ? (
                  <OppositionStatusDetailsView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("discussion", "notice-to-client", savedLeadId);
                    }}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "notice-to-client" ? (
                  <OppositionNoticeToClientView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("discussion", "inform-client", savedLeadId);
                    }}
                    onSentStatusChange={setNoticeSent}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "inform-client" ? (
                  <OppositionInformClientView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("discussion", "call-client", savedLeadId);
                    }}
                    onSentStatusChange={setInformClientSent}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "call-client" ? (
                  <OppositionCallClientView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("discussion", "client-confirmation", savedLeadId);
                    }}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "client-confirmation" ? (
                  <OppositionClientConfirmationView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("discussion", "invoice", savedLeadId);
                    }}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "invoice" ? (
                  <OppositionInvoiceToClientView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("discussion", "payment", savedLeadId);
                    }}
                    onSentStatusChange={setInvoiceSent}
                  />
                ) : activeTab === "discussion" && activeMenuItem === "payment" ? (
                  <OppositionPaymentFromClientView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("filing", "prepare-opposition", savedLeadId);
                    }}
                  />
                ) : activeTab === "filing" && activeMenuItem === "prepare-opposition" ? (
                  <OppositionPrepareOppositionView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("filing", "file-opposition", savedLeadId);
                    }}
                  />
                ) : activeTab === "filing" && activeMenuItem === "file-opposition" ? (
                  <OppositionFileOppositionView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("filing", "inform-client-of-filing", savedLeadId);
                    }}
                  />
                ) : activeTab === "filing" && activeMenuItem === "inform-client-of-filing" ? (
                  <OppositionInformClientOfFilingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("filing", "notice-of-opposition", savedLeadId);
                    }}
                    onSentStatusChange={setInformClientOfFilingSent}
                  />
                ) : activeTab === "filing" && activeMenuItem === "notice-of-opposition" ? (
                  <OppositionNoticeOfOppositionByRegistryView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("filing", "inform-client-of-notice", savedLeadId);
                    }}
                  />
                ) : activeTab === "filing" && activeMenuItem === "inform-client-of-notice" ? (
                  <OppositionInformClientOfNoticeOfOppositionView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "status-details-counter", savedLeadId);
                    }}
                    onSentStatusChange={setInformClientOfNoticeSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "status-details-counter" ? (
                  <OppositionStatusDetailsForCounterView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "notice-counter", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "notice-counter" ? (
                  <OppositionNoticeToClientForCounterView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "inform-counter", savedLeadId);
                    }}
                    onSentStatusChange={setNoticeCounterSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-counter" ? (
                  <OppositionInformClientAboutCounterView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "call-evidence", savedLeadId);
                    }}
                    onSentStatusChange={setInformCounterSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "call-evidence" ? (
                  <OppositionCallClientForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "confirmation-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "confirmation-evidence" ? (
                  <OppositionConfirmationFromClientForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "invoice-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "invoice-evidence" ? (
                  <OppositionInvoiceToClientForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "payment-evidence", savedLeadId);
                    }}
                    onSentStatusChange={setInvoiceEvidenceSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "payment-evidence" ? (
                  <OppositionPaymentFromClientForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "stamp-paper-to-vendor", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "stamp-paper-to-vendor" ? (
                  <OppositionStampPaperDetailsToVendorView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "stamp-paper-from-vendor", savedLeadId);
                    }}
                    onSentStatusChange={setStampPaperToVendorSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "stamp-paper-from-vendor" ? (
                  <OppositionStampPaperFromVendorView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "documents-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "documents-evidence" ? (
                  <OppositionDocumentsFromClientForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "preparation-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "preparation-evidence" ? (
                  <OppositionPreparationOfEvidenceAffidavitView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "signature-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "signature-evidence" ? (
                  <OppositionSignatureFromClientForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "notarisation-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "notarisation-evidence" ? (
                  <OppositionNotarisationForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "scanning-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "scanning-evidence" ? (
                  <OppositionScanningOfDocumentsForEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "file-evidence-affidavit", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "file-evidence-affidavit" ? (
                  <OppositionFileEvidenceAffidavitView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "inform-filing-evidence", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-filing-evidence" ? (
                  <OppositionInformClientAboutFilingOfEvidenceView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "status-evidence-by-cp", savedLeadId);
                    }}
                    onSentStatusChange={setInformFilingEvidenceSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "status-evidence-by-cp" ? (
                  <OppositionStatusDetailsForEvidenceByCpView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "notice-evidence-by-cp", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "notice-evidence-by-cp" ? (
                  <OppositionNoticeForEvidenceByCpView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "inform-evidence-by-cp", savedLeadId);
                    }}
                    onSentStatusChange={setNoticeEvidenceByCpSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-evidence-by-cp" ? (
                  <OppositionInformClientAboutEvidenceByCpView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "call-rejoinder", savedLeadId);
                    }}
                    onSentStatusChange={setInformEvidenceByCpSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "call-rejoinder" ? (
                  <OppositionCallClientForRejoinderView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "confirmation-rejoinder", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "confirmation-rejoinder" ? (
                  <OppositionConfirmationFromClientForRejoinderView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "invoice-rejoinder", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "invoice-rejoinder" ? (
                  <OppositionInvoiceToClientForRejoinderView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "payment-rejoinder", savedLeadId);
                    }}
                    onSentStatusChange={setInvoiceRejoinderSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "payment-rejoinder" ? (
                  <OppositionPaymentFromClientForRejoinderView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "file-rejoinder", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "file-rejoinder" ? (
                  <OppositionFileRejoinderView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "inform-filing-rejoinder", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-filing-rejoinder" ? (
                  <OppositionInformClientAboutFilingOfRejoinderView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "status-hearing", savedLeadId);
                    }}
                    onSentStatusChange={setInformFilingRejoinderSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "status-hearing" ? (
                  <OppositionStatusDetailsOfHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "notice-hearing", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "notice-hearing" ? (
                  <OppositionNoticeToClientForHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "inform-hearing", savedLeadId);
                    }}
                    onSentStatusChange={setNoticeHearingSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-hearing" ? (
                  <OppositionInformClientAboutHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "invoice-hearing", savedLeadId);
                    }}
                    onSentStatusChange={setInformHearingSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "invoice-hearing" ? (
                  <OppositionInvoiceToClientForHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "call-hearing", savedLeadId);
                    }}
                    onSentStatusChange={setInvoiceHearingSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "call-hearing" ? (
                  <OppositionCallClientForHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "confirmation-hearing", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "confirmation-hearing" ? (
                  <OppositionConfirmationFromClientForHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "invoice-tmm-before", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "invoice-tmm-before" ? (
                  <OppositionInvoiceForTmMBeforeHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "payment-tmm-before", savedLeadId);
                    }}
                    onSentStatusChange={setInvoiceTmMBeforeSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "payment-tmm-before" ? (
                  <OppositionPaymentForTmMBeforeHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "file-tmm-before", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "file-tmm-before" ? (
                  <OppositionFileTmMBeforeHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "inform-filing-tmm-before", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-filing-tmm-before" ? (
                  <OppositionInformClientAboutFilingOfTmMBeforeHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "payment-hearing", savedLeadId);
                    }}
                    onSentStatusChange={setInformFilingTmMBeforeSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "payment-hearing" ? (
                  <OppositionPaymentFromClientForHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "documents-hearing", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "documents-hearing" ? (
                  <OppositionDocumentsFromClientForHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "filing-hearing-document", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "filing-hearing-document" ? (
                  <OppositionFilingOfHearingDocumentView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "note-on-hearing", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "note-on-hearing" ? (
                  <OppositionNoteOnHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      navigateToStep("status", "attend-hearing", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "attend-hearing" ? (
                  <OppositionAttendHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      // Outcome of 4A(xliv) drives routing for the rest of Stage 3.
                      // Pass the freshly-fetched flags directly into advanceFromStatusStep
                      // so the navigation decision uses post-save data, not stale state.
                      refreshAttendHearingFlags(savedLeadId).then((freshFlags) => {
                        advanceFromStatusStep("attend-hearing", savedLeadId, freshFlags);
                      });
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-after-hearing" ? (
                  <OppositionInformClientAfterHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      advanceFromStatusStep("inform-after-hearing", savedLeadId);
                    }}
                    onSentStatusChange={setInformAfterHearingSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "invoice-tmm-after" ? (
                  <OppositionInvoiceForTmMAfterHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      advanceFromStatusStep("invoice-tmm-after", savedLeadId);
                    }}
                    onSentStatusChange={setInvoiceTmMAfterSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "payment-tmm-after" ? (
                  <OppositionPaymentForTmMAfterHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      advanceFromStatusStep("payment-tmm-after", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "file-tmm-after" ? (
                  <OppositionFileTmMAfterHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      advanceFromStatusStep("file-tmm-after", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "inform-filing-tmm-after" ? (
                  <OppositionInformClientAfterFilingTmMAfterHearingView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      advanceFromStatusStep("inform-filing-tmm-after", savedLeadId);
                    }}
                    onSentStatusChange={setInformFilingTmMAfterSent}
                  />
                ) : activeTab === "status" && activeMenuItem === "subsequent-hearings" ? (
                  <OppositionSubsequentHearingsView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      advanceFromStatusStep("subsequent-hearings", savedLeadId);
                    }}
                  />
                ) : activeTab === "status" && activeMenuItem === "final-order" ? (
                  <OppositionFinalOrderToClientView
                    leadId={leadId ?? undefined}
                    onSuccess={(savedLeadId) => {
                      // Last step in the Opposition workflow — stay on this step.
                      navigateToStep("status", "final-order", savedLeadId);
                    }}
                  />
                ) : (
                  <InactiveStepView
                    title="Step coming soon"
                    body="This step has not been implemented yet. Please continue with the available steps."
                    buttonText="Back to Preliminary Discussion"
                    onButtonClick={() =>
                      navigateToStep("discussion", "preliminary", leadId ?? null)
                    }
                  />
                )}
              </div>

              {/* Footer */}
              <div className="border-t border-[#EEE] p-3 flex items-center justify-between gap-2 flex-shrink-0">
                <button
                  type="button"
                  disabled={!canGoBack}
                  onClick={() => {
                    if (!canGoBack) return;
                    const prevId =
                      activeTab === "status"
                        ? prevStatusStepId
                        : leftPanelItems[activeIdx - 1]?.id ?? null;
                    if (!prevId) return;
                    navigateToStep(activeTab, prevId, leadId ?? null);
                  }}
                  className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7] disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  Back
                </button>
                <div className="flex items-center gap-2 sm:gap-3 md:gap-5">
                  <button
                    type="button"
                    onClick={() => navigate("/dashboard/opposition")}
                    className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                  >
                    Close
                  </button>
                  {activeMenuItem === "payment" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("filing", "prepare-opposition", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "notice-of-opposition" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("filing", "inform-client-of-notice", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "payment-evidence" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("status", "stamp-paper-to-vendor", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "payment-rejoinder" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("status", "file-rejoinder", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "payment-hearing" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("status", "documents-hearing", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "payment-tmm-before" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("status", "file-tmm-before", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "documents-evidence" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("status", "preparation-evidence", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "invoice-tmm-before" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("status", "payment-tmm-before", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "documents-hearing" && (
                    <button
                      type="button"
                      onClick={() => navigateToStep("status", "filing-hearing-document", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  {activeMenuItem === "invoice-tmm-after" && (
                    <button
                      type="button"
                      onClick={() => advanceFromStatusStep("invoice-tmm-after", leadId ?? null)}
                      className="px-4 py-2 h-9 text-[12px] font-semibold text-[#6D6D6D] border border-[#EEE] rounded-[6px] bg-white hover:bg-[#F7F7F7]"
                    >
                      Progress
                    </button>
                  )}
                  <button
                    type={submitForm ? "submit" : "button"}
                    form={submitForm ?? undefined}
                    disabled={!submitForm}
                    className="px-4 py-2 h-9 min-w-[128px] text-[12px] font-semibold text-white rounded-[6px] bg-[#222] hover:bg-[#333] disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {primaryActionLabel}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
